import React, { Component } from "react"
import HandlingAccordion from "./handling-accordion-component"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"

export default class HandlingAccordionContainer extends Component {
  render() {
    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    return (
      <div className={`handling-accordion ${topPadding ? topPadding : ""}`}>
        <div className="w--wider">
          <div className="infotext">
            <h4>{this.props.headline}</h4>
            <div className="maintext">{ReactHtmlParser(this.props.text)}</div>
          </div>
          {this.props.contentArea && this.props.contentArea.length > 0
            ? this.props.contentArea.map((item, index) => {
                return <HandlingAccordion key={index} {...item} language={this.props.language} />
              })
            : ""}
        </div>
      </div>
    )
  }
}
